import { render, staticRenderFns } from "./testTab.vue?vue&type=template&id=1aa53b29&scoped=true&"
import script from "./testTab.vue?vue&type=script&lang=js&"
export * from "./testTab.vue?vue&type=script&lang=js&"
import style0 from "./testTab.vue?vue&type=style&index=0&id=1aa53b29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa53b29",
  null
  
)

export default component.exports